// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Companies',
  subtitle: 'Manage all company information',
  addNew: 'New Company',
  edit: 'Edit',
  searchPlaceholder: 'Search companies...',
  filterAll: 'All',
  filterActive: 'Active',
  filterInactive: 'Inactive',
  resultsFound: 'companies found',
  noCompanies: 'No companies yet',
  noCompaniesFiltered: 'No search results found',
  noCompaniesDesc: 'Try different search terms',
  noCompaniesStart: 'Start by adding your first company.',
  tableCompany: 'Company',
  tableContact: 'Contact',
  tableCustomer: 'Customer',
  tableAddress: 'Address',
  tableStatus: 'Status',
  tableActions: 'Actions',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  activate: 'Activate',
  deactivate: 'Deactivate',
  view: 'View',
  delete: 'Delete',
  companyDetails: 'Company Details',
  detailName: 'Company Name',
  detailEmail: 'E-mail',
  detailPhone: 'Phone',
  detailWebsite: 'Website',
  detailTaxNumber: 'Tax Number',
  detailAddress: 'Address',
  detailDescription: 'Description',
  detailRegDate: 'Registration Date',
  close: 'Close',
  deleteConfirm: 'Are you sure you want to delete this company?',
  companyAdded: 'Company successfully added',
  companyUpdated: 'Company successfully updated',
  companyDeleted: 'Company successfully deleted',
  fetchError: 'Data could not be retrieved',
  addError: 'Company could not be added',
  updateError: 'Company could not be updated',
  deleteError: 'Company could not be deleted',
  export: 'Export',
  operationFailed: 'Operation failed',
  selectToDelete: 'Select companies to delete',
  loginRequired: 'You need to login',
  bulkDeleteConfirm: 'Are you sure you want to delete {{count}} companies?',
  sessionExpired: 'Your session has expired. Please login again.',
  bulkDeleteFailed: 'Bulk delete failed',
  connectionError: 'Connection error',
  name: 'Company Name',
  address: 'Address',
  phone: 'Phone',
  email: 'E-mail',
  website: 'Website',
  taxNumber: 'Tax Number',
  description: 'Description',
  latitude: 'Latitude',
  longitude: 'Longitude',
  country: 'Country',
  city: 'City',
  sheetName: 'Companies',
  exportSuccess: 'Companies exported successfully',
  editTitle: 'Edit Company',
  addTitle: 'Add New Company',
  locationInfo: 'Location Information',
  debugCountry: 'Country',
  debugState: 'City',
  coordinateInfo: 'Coordinate Information',
  latitudePlaceholder: 'Ex: 41.0082',
  longitudePlaceholder: 'Ex: 28.9784',
  saving: 'Saving...',
  update: 'Update',
  add: 'Add',
  cancel: 'Cancel',
  selectedCount: '{{count}} companies selected',
  deleteSelected: 'Delete Selected',
  contact: 'Contact',
  location: 'Location',
  status: 'Status',
  noSearchResults: 'No search results found',
  notSpecified: 'Not specified',
  detailsTitle: 'Company Details',
  createdAt: 'Created At',
  updatedAt: 'Updated At'
};
